<div class="form-input">
  @if (label) {
    <label [for]="idHTML">
      {{ label | transloco }}@if (isRequired) {
      <span>*</span>
    }
  </label>
}
<mat-form-field appearance="outline">
  <input
    matInput
    [id]="idHTML"
    [placeholder]="placeholder | transloco"
    [formControl]="_control"
    [matDatepicker]="picker"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="setFormValue($event)"
    [matDatepickerFilter]="dateFilter"
    readonly/>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [startAt]="startAt"></mat-datepicker>
  @if (_control.invalid) {
    <mat-error>
      {{ errorMessage | transloco: errorParams }}
    </mat-error>
  }
</mat-form-field>
</div>
